import React from 'react';
import { GiFairyWings } from 'react-icons/gi';
import { Helmet } from "react-helmet-async";
import './History.css';

// Import your history image (update path if needed)
import historyImg from '../../../assets/home/onkar-singh.jpg';

const History = () => {
  return (
    <>
      <Helmet>
        <title>History | Rajput Shiksha Kosh</title>
        <meta
          name="description"
          content="Learn about the history and founding of Rajput Shiksha Kosh."
        />
      </Helmet>
    <section className="history-of-rajputshikshakosh-wrapper">
      <div className="history-of-rajputshikshakosh-container">
        
        {/* --- 1. HEADER (Title + Divider) --- */}
        <div className="history-of-rajputshikshakosh-header">
          <h2 className="history-of-rajputshikshakosh-title">HISTORY OF RAJPUT SHIKSHA KOSH</h2>
          <div className="history-of-rajputshikshakosh-divider">
            <span className="history-of-rajputshikshakosh-line"></span>
            <GiFairyWings className="history-of-rajputshikshakosh-icon" />
            <span className="history-of-rajputshikshakosh-line"></span>
          </div>
        </div>

        {/* --- 2. SMALL CENTERED IMAGE (Outside the main box) --- */}
        <div className="history-of-rajputshikshakosh-img-outer-box">
          <img 
            src={historyImg} 
            alt="Rajput Shiksha Kosh Foundation" 
            className="history-of-rajputshikshakosh-small-img" 
          />
        </div>

        {/* --- 3. MAIN CONTENT DIV (White Background) --- */}
        <div className="history-of-rajputshikshakosh-content-card">
          {/* --- SUBTITLE LINE --- */}
          <h3 className="history-of-rajputshikshakosh-sub-heading-line">
            स्थापना एवं गौरवशाली यात्रा
          </h3>
          
          <p className="history-of-rajputshikshakosh-salutation">राजपूत शिक्षा कोष का उदय,</p>
          
          <p className="history-of-rajputshikshakosh-paragraph">
            राजपूत शिक्षा कोष की स्थापना समाज के उन प्रतिभावान और होनहार बच्चों के भविष्य को संवारने के एक महान संकल्प के साथ की गई थी, जो केवल आर्थिक अभावों के कारण उच्च शिक्षा से वंचित रह जाते थे। समाज की एक बड़ी आबादी की विषम परिस्थितियों को देखते हुए इस गुदड़ी के लालों को शिक्षा दान देने का एक सार्थक प्रयास अनिवार्य हो गया था।
          </p>

          <p className="history-of-rajputshikshakosh-paragraph">
            इस पुनीत कार्य का बीजारोपण आदरणीय <strong>ठाकुर ओंकार सिंह जी बाबरा आई.ए.एस (रिटा.)</strong> की दूरदर्शी सोच से हुआ। उन्होंने आभावग्रस्त प्रतिभावान छात्रों की शिक्षा व्यवस्था हेतु नियमित रूप से छात्रवृत्ति प्रदान करने के लिए <strong>१० करोड़ रुपये के स्थाई कोष</strong> के गठन का ऐतिहासिक प्रस्ताव रखा और इसकी स्थापना हेतु अपनी तरफ से <strong>५ लाख रुपये</strong> का प्रारंभिक अंशदान प्रदान कर इस महायज्ञ की शुरुआत की।
          </p>

          <p className="history-of-rajputshikshakosh-paragraph">
            उनके इस प्रेरक एवं महत्वपूर्ण प्रस्ताव पर तत्काल कार्यवाही शुरू कर दी गई। जुलाई 2017 में इस संस्था ने अपने उद्देश्य को धरातल पर उतारते हुए सर्वप्रथम 10 जरूरतमंद प्रतिभावान छात्रों को <strong>06,02,000/-</strong> रुपये की छात्रवृत्तियां प्रदान कर एक नई सुबह का शंखनाद किया।
          </p>

          <p className="history-of-rajputshikshakosh-paragraph">
            इस अभूतपूर्व विचार के अनुसार अभावग्रस्त बालकों को शिक्षा दान देने की दीर्घ कालीन, निरंतर एवं नियमित व्यवस्था सुनिश्चित करने हेतु 'राजपूत शिक्षा कोष' नामक ट्रस्ट का विधिवत गठन किया गया। समाज ने एक स्वर में 10 करोड़ रुपये का स्थायी कोष (Corpus Fund) बनाने का संकल्प लिया है, जिसकी पूर्ति का दायित्व आज संपूर्ण समाज उठा रहा है।
          </p>

          <p className="history-of-rajputshikshakosh-paragraph">
            संस्था का यह दृढ़ नियम है कि इस स्थायी कोष की मूल राशि (Corpus) में से एक भी पैसा किसी भी परिस्थिति में नहीं निकाला जाएगा। केवल इस फंड के <strong>ब्याज एवं लाभांश</strong> से ही छात्रों को छात्रवृत्तियां अथवा एजुकेशन लोन (Education Loan) दिए जाते हैं। 
          </p>

          <p className="history-of-rajputshikshakosh-paragraph">
            आज अनेक भामाशाह, प्रबुद्ध जन और समाज हितैषी अपने-अपने सामर्थ्य के अनुसार इस कोष में वन-टाइम (One-time) सहयोग राशि देकर समाज के उन्नयन में भागीदार बन रहे हैं। यह संस्था अब केवल एक आर्थिक कोष नहीं, बल्कि समाज के सशक्तिकरण और शिक्षा की ज्योति को निरंतर जलाए रखने का एक जीवंत प्रतीक बन चुकी है।
          </p>

          <p className="history-of-rajputshikshakosh-blessing">
            "शिक्षा दान ही समाज के उत्थान का सबसे बड़ा महादान है।"
          </p>

          {/* --- SIGNATURE --- */}
          <div className="history-of-rajputshikshakosh-footer-sig">
            <h4>राजपूत शिक्षा कोष</h4>
            <p>प्रबंध समिति (Trustee Board)</p>
            <p>पंजीकृत ट्रस्ट, राजस्थान</p>
          </div>
        </div>

      </div>
    </section>
    </>
  );
};

export default History;